<template>
  <div class="root">
    <div v-if="countInstallations" class="installation-head">
      <button @click="hidden = !hidden" class="installation-button">
        <img v-if="hidden" src="../../files/plus-icon.svg" alt="plus-icon" />
        <img v-else src="../../files/minus-icon.svg" alt="minus-icon" />
      </button>
      <p v-if="countInstallations" class="installation-head-title">Установки ({{ countInstallations }})</p>
      <img v-if="isErrors" src="../../files/alert-icon.svg" alt="alert icon" />
    </div>

    <ul
      :class="[
        'installation-list',
        {
          'installation-list_hidden': hidden,
        },
      ]"
      v-if="installations && installations.length > 0"
    >
      <li class="installation-list-item" :key="installation.id" v-for="(installation, i_index) in installations">
        <div
          class="installation-item"
          draggable="true"
          @dragstart.stop="installationDragStart($event, installation, i_index)"
          @dragend.stop="installationDragEnd()"
        >
          <div class="installation-item-icon-block">
            <button
              @click.prevent="toggleObjectShow(installation.id)"
              :class="[
                'installation-button',
                {
                  'installation-button_hidden':
                    !installation.mapObjects || (installation.mapObjects && installation.mapObjects.length === 0),
                },
              ]"
            >
              <img v-if="!openedObjects.includes(installation.id)" src="../../files/plus-icon.svg" alt="plus-icon" />
              <img v-else src="../../files/minus-icon.svg" alt="minus-icon" />
            </button>
            <div class="installation-icon-wrapper">
              <img
                :src="getInstallationImage(installation.obj_type)"
                :id="`drag${i_index}`"
                :class="[
                  'grabbable',
                  'installation-icon-image',
                  {
                    'installation-icon_disabled': installation.exclude && parseInt(installation.exclude) != 0,
                  },
                ]"
              />
              <!-- Иконка исключенного из расчета -->
              <img
                src="../../assets/icons/disabled-icon.svg"
                v-if="installation.exclude && parseInt(installation.exclude) != 0"
                class="installation-exclude-icon"
              />
            </div>

            <div class="installation-badge">
              <p v-if="lvgCodes.includes(parseInt(installation.obj_type))" class="installation-badge-text">ЛВЖ/ГЖ</p>
              <p v-if="sugCodes.includes(parseInt(installation.obj_type))" class="installation-badge-text">СУГ/СПГ</p>
              <p v-if="gasCodes.includes(parseInt(installation.obj_type))" class="installation-badge-text">ГАЗ</p>
            </div>
          </div>

          <p class="installation-item-name">
            {{ installation.name }} ({{ (installation.mapObjects && installation.mapObjects.length) || 0 }})

            <!-- Ошибки установки -->
            <button
              :id="installation.id"
              class="installation-item-error-button"
              v-if="installation.errors"
              @click="showErrors(installation.errors)"
            >
              <img src="../../files/alert-icon.svg" alt="alert icon" />
            </button>
            <main-tooltip :target="installation.id" tooltipValue="Возникли ошибки" />
          </p>

          <!-- Контекстное меню установки -->
          <installation-dropdown
            :handleDropdownClick="handleDropdownClick"
            :shiftY="shiftY"
            :index="i_index"
            @onFullTurnOff="handleFullTurnOff({ id: installation.id, index: i_index })"
            :installation="installation"
            @onScenarioInformationClick="handleScenarioInformationClick(installation)"
            @onEditClick="handleEditClick({ installation, index: i_index })"
            @onRemoveClick="handleRemoveClick({ installation, index: i_index })"
            @onScenarioConstructorClick="curInstallation = installation"
          />
        </div>

        <ul
          :class="[
            'submenu-map-objects',
            {
              'submenu-map-objects_opened': openedObjects.includes(installation.id),
            },
          ]"
          v-if="installation.mapObjects && installation.mapObjects.length > 0"
        >
          <li class="submenu-map-objects-item" :key="object.id" v-for="(object, index) in installation.mapObjects">
            <div class="submenu-map-objects-item-head">
              <button
                @click.prevent="toggleObjectShow(object.id)"
                :class="[
                  'installation-button',
                  {
                    'installation-button_hidden':
                      !object.pipelines || (object.pipelines && object.pipelines.length === 0),
                  },
                ]"
              >
                <img v-if="!openedObjects.includes(object.id)" src="../../files/plus-icon.svg" alt="plus-icon" />
                <img v-else src="../../files/minus-icon.svg" alt="minus-icon" />
              </button>
              <div class="installation-icon-wrapper">
                <button
                  :class="[
                    'submenu-map-objects-button',
                    {
                      'installation-icon_disabled': object.exclude && parseInt(object.exclude) != 0,
                    },
                  ]"
                  :style="{ 'background-color': installation.color }"
                  @mouseover="
                    $set(installations[i_index].mapObjects[index], 'focused', true);
                    object.focused = true;
                  "
                  @mouseleave="$set(installations[i_index].mapObjects[index], 'focused', false)"
                >
                  {{ object.icon_text }}
                </button>
                <!-- Иконка исключенного из расчета -->
                <img
                  src="../../assets/icons/disabled-icon.svg"
                  v-if="object.exclude && parseInt(object.exclude) != 0"
                  class="installation-exclude-icon"
                />
              </div>

              <div class="submenu-piplenes">
                <span class="submenu-map-objects-text black">
                  Точка: {{ object.icon_text }} ({{ object.pipelines ? object.pipelines.length : "0" }})
                </span>
                <span class="submenu-map-objects-text">
                  Кол-во установок:<span class="submenu-map-objects-number"> {{ object.count }}</span>
                </span>
              </div>

              <!-- Контекстное меню точки -->
              <map-object-dropdown
                :handleDropdownClick="handleDropdownClick"
                :shiftY="shiftY"
                :index="index"
                :installationIndex="i_index"
                :installation="installation"
                :object="object"
                @onObjectTurnOff="handleObjectTurnOff"
                @onPipelineConnect="pipelineConnect"
                @onObjectDelete="handleObjectDelete"
                @onEditMapObject="
                  $emit('editDot');
                  $emit(
                    'update:temp',
                    Object.assign({ index: index, i_index: i_index, obj_type: installation.obj_type }, object)
                  );
                "
              />
            </div>

            <!-- Трубопроводы -->
            <ul
              :class="[
                'submenu-map-objects',
                'submenu-map-objects_pipelines',
                {
                  'submenu-map-objects_opened': openedObjects.includes(object.id),
                },
              ]"
              v-if="object.pipelines && object.pipelines.length > 0"
            >
              <li
                class="submenu-map-objects-item submenu-map-pipeline-item"
                :key="pipeline.id"
                v-for="(pipeline, pipe_index) in object.pipelines"
              >
                <div class="installation-icon-wrapper">
                  <button
                    @click.prevent
                    :class="[
                      'submenu-pipeline-objects-button',
                      {
                        'installation-icon_disabled': pipeline.exclude && parseInt(pipeline.exclude) != 0,
                      },
                    ]"
                    @mouseover="
                      $set(installations[i_index].mapObjects[index], 'focused', true);
                      object.focused = true;
                    "
                    @mouseleave="$set(installations[i_index].mapObjects[index], 'focused', false)"
                  >
                    <img
                      v-if="pipeline.obj_type == 62"
                      class="submenu-map-objects-icon"
                      src="../../assets/icons/flexible_technological_turbine.svg"
                      alt="pipeline icon"
                    />
                    <img
                      v-else
                      class="submenu-map-objects-icon"
                      src="../../assets/icons/pipelines.svg"
                      alt="pipeline icon"
                    />
                  </button>

                  <!-- Иконка исключенного из расчета -->
                  <img
                    src="../../assets/icons/disabled-icon.svg"
                    v-if="pipeline.exclude && parseInt(pipeline.exclude) != 0"
                    class="installation-exclude-icon"
                  />
                </div>

                <span :style="{ 'background-color': installation.color }" class="submenu-piplene-label" />

                <div class="submenu-piplenes">
                  <span class="submenu-map-objects-text black">
                    {{ pipeline.name }}
                  </span>
                  <span class="submenu-map-objects-text"
                    >Радиус: <span class="black">{{ pipeline.R }}</span>
                  </span>
                  <span class="submenu-map-objects-text"
                    >Длина: <span class="black">{{ pipeline.L }}</span>
                  </span>
                </div>

                <!-- Контекстное меню трубопровода -->

                <installation-dropdown
                  :handleDropdownClick="handleDropdownClick"
                  :shiftY="shiftY"
                  :index="i_index"
                  @onFullTurnOff="pipelineTurnOff(i_index, index, pipeline.id, pipe_index)"
                  :installation="installation"
                  @onScenarioInformationClick="handlePipelineScenarioInformationClick(pipeline)"
                  @onEditClick="handlePipelineEditClick({ i_index, index, pipe_index, object, pipeline })"
                  @onRemoveClick="openDeletePipileneModal({ i_index, index, pipe_index, pipeline })"
                  @onScenarioConstructorClick="curInstallation = pipeline"
                  :pipeline="pipeline"
                />
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>

    <!-- Модалки, будут переделываться в рамках следующих задач -->
    <b-modal
      size="xl"
      id="factorsDataDispanser"
      ref="factorsDataDispanser"
      hide-footer
      title="Просмотр информации по сценариям"
    >
      <factorsDataDispanser :object="curInstallation" />
    </b-modal>

    <b-modal size="xl" id="factorsData" ref="factorsData" hide-footer title="Просмотр информации по сценариям">
      <factorsData :object="curInstallation" />
    </b-modal>

    <b-modal
      size="xl"
      lazy
      dialog-class="modal-fullscreen-dialog"
      content-class="modal-fullscreen-content"
      id="tree"
      hide-footer
      title="Конструктор сценариев"
    >
      <tree :object="curInstallation" @clearCalculations="$emit('clearCalculations')" />
    </b-modal>

    <!-- Удаление установки -->
    <confirm-modal
      ref="installationRemoveModal"
      hide-footer
      id="installationRemoveModal"
      title="Удалить"
      content="Вы действительно хотите удалить эту технологическую установку?"
      @onSubmitClick="
        objectRemove($refs.installationRemoveModal.index, $refs.installationRemoveModal.object_id);
        $bvModal.hide('installationRemoveModal');
      "
    />

    <!-- Отображение ошибок -->
    <b-modal id="showErrors" ref="showErrors" hide-footer title="Недостаточно данных">
      <center><h5 class="text-danger">Объект сохранён, но не может быть учтён в расчёте.</h5></center>
      <span v-if="cur_errors">
        <h4 v-if="cur_errors.substance">Вещества:</h4>
        <div v-if="cur_errors.substance">
          <div :key="sub_error.substance_id" v-for="sub_error in cur_errors.substance">
            <b-card v-if="sub_error.substance_name" class="mb-3">
              <h3>
                {{ sub_error.substance_name
                }}<b-btn
                  variant="success"
                  size="sm"
                  class="pull-right"
                  @click="
                    $refs.showErrors.hide();
                    $parent.$refs.substances.show();
                    $parent.substanceToShow = { id: sub_error.substance_id, type: sub_error.substance_type };
                  "
                  >Перейти</b-btn
                >
              </h3>
              <b-list-group>
                <b-list-group-item
                  :key="`substances_error-${index}`"
                  v-for="(error, index) in Object.values(sub_error.errors)"
                  >{{ index + 1 }}. {{ error[0] }}</b-list-group-item
                >
              </b-list-group>
            </b-card>
            <b-card v-else> У одного или нескольких объектов не найдено вещество </b-card>
          </div>
        </div>

        <h4 v-if="cur_errors.objects">Оборудование:</h4>
        <div v-if="cur_errors.objects">
          <div :key="`${obj_error.obj_name}`" v-for="obj_error in cur_errors.objects">
            <b-card class="mb-3">
              <h3>{{ obj_error.obj_name }}</h3>
              <b-list-group>
                <b-list-group-item :key="`error-${index}`" v-for="(error, index) in Object.values(obj_error.errors)"
                  >{{ index + 1 }}. {{ error[0] }}</b-list-group-item
                >
              </b-list-group>
            </b-card>
          </div>
        </div>
      </span>
    </b-modal>

    <!-- Удаление точки -->
    <confirm-modal
      ref="installationDotRemoveModal"
      id="installationDotRemoveModal"
      title="Удалить"
      content="Вы действительно хотите удалить технологическую установку из этой точки?"
      @onSubmitClick="
        pointRemove(
          $refs.installationDotRemoveModal.index,
          $refs.installationDotRemoveModal.object_id,
          $refs.installationDotRemoveModal.point_id,
          $refs.installationDotRemoveModal.point_index
        );
        $bvModal.hide('installationDotRemoveModal');
      "
    />

    <!-- Просмотр информации по трубопроводам -->
    <b-modal
      size="xl"
      id="factorsDataPipelines"
      ref="factorsDataPipelines"
      hide-footer
      title="Просмотр информации по сценариям"
    >
      <factorsDataPipelines :object="curInstallation" />
    </b-modal>

    <!-- Редактировать трубопровод -->
    <b-modal size="lg" id="pipelineEdit" ref="pipelineEdit" hide-footer :title="pipelineEditModalTitle">
      <connectedPipeline
        @pipelineWindowClose="$refs.pipelineEdit.hide()"
        @onCancelClick="$refs.pipelineEdit.hide()"
        :newPipeline.sync="curInstallation"
        :substrate="substrate"
        :action.sync="action"
        :installations.sync="installations"
        :proj_id="Number(project.id)"
      />
    </b-modal>

    <!-- Удалить трубопровод -->
    <confirm-modal
      ref="pipelineRemoveModal"
      id="pipelineRemoveModal"
      title="Удалить"
      :content="pipelineDeleteModalTitle"
      @onSubmitClick="
        pipelineRemove(
          $refs.pipelineRemoveModal.i_index,
          $refs.pipelineRemoveModal.o_index,
          $refs.pipelineRemoveModal.p_index,
          $refs.pipelineRemoveModal.object_id
        );
        $bvModal.hide('pipelineRemoveModal');
      "
    />

    <add-installation-modal
      @clearCalculations="$emit('clearCalculations')"
      @newObject="objectAdd"
      :installation="curInstallation"
      :projId="Number(project.id)"
      title="Технологическая установка"
      id="addInstallation"
      :showErrors="showErrors"
    />
    <custom-toast :key="id" v-for="{ content, title, id } in toasts" :content="content" :title="title" :toastId="id" />
  </div>
</template>

<script>
import factorsDataDispanser from "../../views/risks/factorsDataDispanser";
import factorsDataPipelines from "../../views/risks/factorsDataPipelines";
import connectedPipeline from "../../views/risks/objects/connectedPipeline";
import factorsData from "../../views/risks/factorsData";
import tree from "../../views/risks/tree";
import MainTooltip from "../ui/MainTooltip";
import InstallationDropdown from "./components/InstallationDropdown";
import MapObjectDropdown from "./components/MapObjectDropdown";
import AddInstallationModal from "../modals/AddInstallationModal";
import { getImage, handleInstallationDropdownClick } from "../../utils/utils";
import { LVG_CODES, SUG_CODES, GAS_CODES } from "../../constants/constants";
import ConfirmModal from "../modals/ConfirmModal.vue";
import CustomToast from "../ui/CustomToast.vue";

export default {
  props: {
    installations: Array,
    project: Object,
    action: String,
    temp: Object, // используется для передачи в родительский компонент данных для редактировании
    substrate: Object,
    clearCurrentInstallation: Boolean,
  },
  components: {
    factorsDataDispanser,
    factorsData,
    tree,
    MainTooltip,
    factorsDataPipelines,
    connectedPipeline,
    InstallationDropdown,
    MapObjectDropdown,
    AddInstallationModal,
    ConfirmModal,
    CustomToast,
  },
  data() {
    return {
      toasts: [
        {
          title: "Присоединить трубопровод",
          content: "Теперь отметьте точки прохождения трубопровода",
          id: "connect-pipeline-toast",
        },
        {
          title: "Присоединить гибкое соединение",
          content: "Теперь отметьте точки прохождения гибкого соединения",
          id: "connect-flexible-toast",
        },
      ],
      pipelineToDelete: null,
      pipelineСode: "61",
      hidden: false,
      loading: true,
      curInstallation: {},
      cur_errors: null,
      cur_index: null,
      old_graf: null,
      shiftY: 0,
      pumplineConnection: {
        instId: null,
        instIndex: null,
        mapObjectIndex: null,
        pumplineId: null,
      },
      lvgCodes: LVG_CODES,
      sugCodes: SUG_CODES,
      gasCodes: GAS_CODES,
      openedSubmenuIndex: null,
      openedObjects: [],
    };
  },

  computed: {
    countInstallations() {
      return (this.installations && this.installations.length) || 0;
    },

    isErrors() {
      if (this.installations) {
        return this.installations.some((item) => item.errors);
      }
      return false;
    },

    pipelineEditModalTitle() {
      if (
        this.curInstallation &&
        "obj_type" in this.curInstallation &&
        this.curInstallation.obj_type === this.pipelineСode
      ) {
        return "Изменить трубопровод";
      }
      return "Изменить гибкое соединение";
    },

    pipelineDeleteModalTitle() {
      if (this.pipelineToDelete && this.pipelineToDelete === Number(this.pipelineСode)) {
        return "Вы действительно хотите удалить этот трубопровод?";
      }
      return "Вы действительно хотите удалить это гибкое соединение?";
    },
  },

  methods: {
    handlePipelineScenarioInformationClick(pipeline) {
      this.curInstallation = pipeline;
      this.$bvModal.show("factorsDataPipelines");
    },

    handlePipelineEditClick({ i_index, index, pipe_index, object, pipeline }) {
      this.curInstallation = Object.assign(
        {
          obj_index: i_index,
          map_object_index: index,
          pipe_index: pipe_index,
          parentDots: { x: object.lat, y: object.lng },
        },
        pipeline
      );
      this.$bvModal.show("pipelineEdit");
    },

    handleObjectDelete({ installationIndex, installation, object, index }) {
      this.$refs.installationDotRemoveModal.index = installationIndex;
      this.$refs.installationDotRemoveModal.object_id = installation.id;
      this.$refs.installationDotRemoveModal.point_id = object.id;
      this.$refs.installationDotRemoveModal.point_index = index;
      this.$bvModal.show("installationDotRemoveModal");
    },

    toggleObjectShow(id) {
      if (this.openedObjects.includes(id)) {
        this.openedObjects = this.openedObjects.filter((item) => item !== id);
      } else {
        this.openedObjects.push(id);
      }
    },

    openDeletePipileneModal({ i_index, index, pipe_index, pipeline }) {
      this.pipelineToDelete = Number(pipeline.obj_type);
      this.$refs.pipelineRemoveModal.i_index = i_index;
      this.$refs.pipelineRemoveModal.o_index = index;
      this.$refs.pipelineRemoveModal.p_index = pipe_index;
      this.$refs.pipelineRemoveModal.object_id = pipeline.id;
      this.$bvModal.show("pipelineRemoveModal");
    },

    pipelineTurnOff(i_index, index, pipeline_id, p_index) {
      this.$http
        .post("risk/objects/pipeline-exclude?proj_id=" + this.project.id + "&pipeline_id=" + pipeline_id)
        .then((response) => {
          this.$set(this.installations[i_index].mapObjects[index].pipelines[p_index], "exclude", response.data);
          this.oldData = true;
        })
        .catch((err) => {
          console.error(`Ошибка: ${err}`);
        })
        .finally(() => this.$emit("clearCalculations"));
    },

    pipelineRemove(i_index, o_index, p_index, object_id) {
      this.$http
        .post("risk/objects/pipeline-remove?proj_id=" + this.project.id + "&id=" + object_id)
        .then(() => {
          this.installations[i_index].mapObjects[o_index].pipelines.splice(p_index, 1);
        })
        .catch((err) => {
          console.error(`Ошибка: ${err}`);
        });
    },

    handleDropdownClick(event) {
      this.shiftY = handleInstallationDropdownClick(event);
    },

    showErrors(errors) {
      this.cur_errors = errors;
      this.$refs.showErrors.show();
    },
    getInstallationImage(type) {
      return getImage(parseInt(type));
    },

    handleFullTurnOff({ id, index }) {
      this.$http
        .post("risk/objects/exclude-full?proj_id=" + this.project.id + "&id=" + id)
        .then((response) => {
          this.$set(this.installations[index], "exclude", response.data);
          this.oldData = true;
        })
        .catch((err) => {
          console.error(`Ошибка: ${err}`);
        })
        .finally(() => this.$emit("clearCalculations"));
    },

    handleScenarioInformationClick(installation) {
      this.curInstallation = installation;
      installation.obj_type == 21 ? this.$refs.factorsDataDispanser.show() : this.$refs.factorsData.show();
    },

    handleEditClick({ installation, index }) {
      this.curInstallation = installation;
      this.cur_index = index;
      this.old_graf = installation.Pot_rs_graf;
      this.$bvModal.show("addInstallation");
    },

    handleRemoveClick({ installation, index }) {
      this.$bvModal.show("installationRemoveModal");
      this.$refs.installationRemoveModal.index = index;
      this.$refs.installationRemoveModal.object_id = installation.id;
    },

    objectRemove(index, id) {
      this.$emit("excludeObject", { i_index: index, action: "exclude" });
      this.$http
        .post("risk/objects/remove?proj_id=" + this.project.id + "&id=" + id)
        .then(() => {
          this.installations.splice(index, 1);
          this.$emit("clearCalculations")
        })
        .catch((e) => {
          if (e.response.data) {
            this.$emit("excludeObject", { i_index: index, action: "include" });
          }
        });
    },

    objectAdd(model) {
      if (!this.installations) {
        this.$emit("update:installations", [model]);
      } else {
        this.installations.unshift(model);
      }
      if (model.errors) {
        this.showErrors(model.errors);
      }
      this.$bvModal.hide("addInstallation");
    },

    installationDragStart(ev, installation, index) {
      this.$emit("update:temp", Object.assign({ type: "tank", index: index }, installation));
      document.body.style.cursor = "move";
    },

    installationDragEnd() {
      document.body.style.cursor = "default";
    },

    handleObjectTurnOff({ objectId, installationId, installationIndex, index }) {
      this.$http
        .post("risk/objects/exclude?proj_id=" + this.project.id + "&id=" + installationId + "&point_id=" + objectId)
        .then((response) => {
          this.$set(this.installations[installationIndex].mapObjects[index], "exclude", response.data);
          this.oldData = true;
        })
        .catch((err) => {
          console.error(`Ошибка: ${err}`);
        })
        .finally(() => this.$emit("clearCalculations"));
    },

    pipelineConnect({ objectId, installationIndex, index, type }) {
      const data = {};
      data.obj_id = objectId;
      data.obj_index = installationIndex;
      data.obj_type = type;
      data.map_object_index = index;
      this.$emit("update:temp", data);
      this.$emit("update:action", "pipelineConnect");
      if (type == 61) {
        this.$bvToast.show("connect-pipeline-toast");
      }

      if (type == 62) {
        this.$bvToast.show("connect-flexible-toast");
      }
    },

    pointRemove(index, id, point_id, point_index) {
      this.$http
        .post("risk/objects/remove-point?proj_id=" + this.project.id + "&id=" + id + "&point_id=" + point_id)
        .then(() => {
          this.installations[index].mapObjects.splice(point_index, 1);
          this.$emit("clearCalculations")
        })
        .catch((err) => {
          console.error(`Ошибка: ${err}`);
        });
    },
  },

  watch: {
    installations() {
      if (!this.openedObjects.length && this.installations) {
        this.installations.forEach((item) => {
          if (item.mapObjects && item.mapObjects.length) {
            item.mapObjects.forEach((object) => {
              this.openedObjects.push(object.id);
            });
          }
          this.openedObjects.push(item.id);
        });
      }
    },
    clearCurrentInstallation() {
      this.curInstallation = {};
    },
  },
};
</script>

<style scoped>
.root {
  margin-top: 16px;
}
.installation-head {
  display: flex;
  align-items: center;
  gap: 4px;
}
.installation-button {
  position: relative;
  z-index: 1;
  border: none;
  padding: 0;
  background: var(--white-color);
}
.installation-button_hidden {
  visibility: hidden;
}
.installation-list-item {
  position: relative;
  margin-bottom: 8px;
}
.installation-head-title {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--black-color);
  margin: 0;
}
.installation-item-icon-block {
  position: relative;
  z-index: 1;
  display: flex;
}
.installation-icon-wrapper {
  position: relative;
  width: max-content;
}
.installation-icon-image {
  display: block;
  width: 32px;
  height: 32px;
  object-fit: cover;
}
.installation-exclude-icon {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.installation-badge {
  min-width: 35px;
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  right: -2px;
  padding: 0px 4px;
  border-radius: 20px;
  background: var(--additional-color);
  pointer-events: none;
}
.installation-badge-text {
  margin: 0;
  color: var(--white-color);
  font-size: 6px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 600;
  line-height: 10px;
}
.installation-item {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: grab;
}
.installation-item-error-button {
  background: transparent;
  border: none;
}
.installation-item-name {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  font-size: 12px;
  color: var(--black-color);
  margin: 0;
  flex-grow: 1;
}
.installation-list {
  margin-top: 8px;
  padding-left: 8px;
  max-height: 100%;
  overflow: auto;
}

.installation-list_hidden {
  max-height: 0;
  overflow: hidden;
}
.installation-list-submenu-button {
  padding: 0;
  border: 0;
  min-width: 16px;
  width: 16px;
  height: 16px;
  background: transparent;
}
.submenu-wrapper {
  position: absolute;
  right: 0;
  top: 30px;
  padding: 12px;
  background: var(--white-color);
  z-index: 3;
  border-radius: 4px;
  box-shadow: 0px 4px 8px 0px rgba(0, 46, 166, 0.15);
}

.submenu-map-objects {
  padding-left: 40px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 0;
  overflow: hidden;
}
.submenu-map-objects_pipelines {
  padding-left: 38px;
}
.submenu-map-objects_opened {
  max-height: 1000px;
  padding-top: 7px;
}
.submenu-map-objects-item {
  position: relative;
}
.submenu-map-objects-item::before {
  content: "";
  position: absolute;
  top: -18px;
  left: -10px;
  width: 21px;
  height: 35px;
  border-left: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
}
.submenu-map-objects-item::after {
  content: "";
  position: absolute;
  top: 0;
  left: -10px;
  width: 21px;
  height: 100%;
  border-left: 1px solid var(--border-color);
}
.submenu-map-objects-item:last-of-type:after {
  display: none;
}
.submenu-map-objects-button {
  position: relative;
  border: none;
  padding: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px;
  color: var(--white-color);
  opacity: 1;
  transition: opacity 0.15s ease-out;
  z-index: 1;
}
.submenu-map-objects-button:hover {
  opacity: 0.75;
}
.submenu-map-objects-text {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  color: var(--grey-3-color);
  margin-left: 4px;
  flex-grow: 1;
}
.submenu-map-objects-number {
  color: var(--black-color);
}
.submenu-map-objects-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.submenu-map-pipeline-item {
  display: flex;
}
.submenu-map-pipeline-item::before {
  top: -22px;
}
.submenu-piplenes {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 4px;
}
.submenu-piplene-label {
  position: absolute;
  display: inline-block;
  min-width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 0 4px;
  top: 0;
  left: 21px;
  z-index: 2;
}
.submenu-map-objects-item-head {
  display: flex;
  align-items: center;
}

.submenu-pipeline-objects-button {
  position: relative;
  bottom: 3px;
  z-index: 1;
  width: 32px;
  height: 32px;
  background: var(--white-color);
  padding: 0;
  border: none;
}

.installation-icon_disabled {
  opacity: 0.5;
}

.pipelines-count {
  position: absolute;
  top: 5px;
  right: 5px;
  font-family: "Inter", sans-serif;
  font-size: 6px;
  font-style: normal;
  font-weight: 700;
  line-height: 7px;
  color: var(--white-color);
}
</style>
